import IEnquiry from "../models/contact/IEnquiry";
import networkService from "./NetworkService";

class ContactService {

    /**
     * @description Submits the contact form with the provided enquiry details.
     * @param {IEnquiry} enquiry - The enquiry details to be submitted.
     */
    async submitEnquiry(enquiry: IEnquiry): Promise<boolean> {
        const result = await networkService.post<IEnquiry, void>(`/contact`, enquiry);
        return result.isSuccessful;
    }
}

const contactService = new ContactService();
export default contactService;